export default __webpack_public_path__ + "static/media/password.e9a5547f.svg";